import { gql } from '@apollo/client'

export const manufacturerProductImageDetailFragment = gql`
    fragment manufacturerProductImageDetailFragment on ManufacturerProductImageDetail {
        id
        order
        filename
        isPrimary
        originalFilename
    }
`
export const manufacturerProductVideoDetailFragment = gql`
    fragment manufacturerProductVideoDetailFragment on ManufacturerProductVideoDetail {
        id
        order
        videoStillImageUrl
        fromSource
        videoId
    }
`

export const manufacturerProductBimLinkDetailFragment = gql`
    fragment manufacturerProductBimLinkDetailFragment on ManufacturerProductBimLinkDetail {
        bimUrl
        imageUrl
        productDescription
        productName
    }
`
export const manufacturerProductPropertiesOptionFragment = gql`
    fragment manufacturerProductPropertiesOptionFragment on ManufacturerProductPropertyOptionDetail {
        isOther
        isPremium
        isPremiumPlus
        isSupported
        optionId
        value
        isUnitOfMeasure
        metricUnits
        imperialUnits
        isInlineTextOnly
    }
`

export const manufacturerProductPropertiesOptionGroupFragment = gql`
    fragment manufacturerProductPropertiesOptionGroupFragment on ManufacturerProductPropertyOptionGroupDetail {
        groupId
        prefix
        postfix
        options {
            ...manufacturerProductPropertiesOptionFragment
        }
    }
    ${manufacturerProductPropertiesOptionFragment}
`

export const manufacturerProductCatalogDetailFragment = gql`
    fragment manufacturerProductCatalogDetailFragment on ManufacturerProductCatalogDetail {
        path
        thumbnailPath
        title
        uploadedDate
    }
`

export const manufacturerProductSpecDocDetailFragment = gql`
    fragment manufacturerProductSpecDocDetailFragment on ManufacturerProductSpecDocDetail {
        docType
        docVariation
        expirationDate
        path
        title
        id
    }
`
export const manufacturerProductWebLinkDetailFragment = gql`
    fragment manufacturerProductWebLinkDetailFragment on ManufacturerProductWebLinkDetail {
        order
        type
        url
    }
`

export const manufacturerProductPropertyDetailFragment = gql`
    fragment manufacturerProductPropertyDetailFragment on ManufacturerProductPropertyDetail {
        options {
            ...manufacturerProductPropertiesOptionFragment
        }
        optionGroups {
            ...manufacturerProductPropertiesOptionGroupFragment
        }
        propertyId
        propertyName
        isPremiumPlus
    }
    ${manufacturerProductPropertiesOptionFragment}
    ${manufacturerProductPropertiesOptionGroupFragment}
`

export const partnershipFragment = gql`
    fragment partnershipFragment on Partnership {
        level
        name
        partnerType
        url
    }
`

export const listingMatchFragment = gql`
    fragment listingMatchFragment on ListingMatch {
        listingId
        categories
        displayNameWithFirmName
        firmName
        productName
        productId
        productType
        firmLogoUrl
        sectionName
        specAgentProductTypeId
        type
        submissionStatus
        lastUpdated
        isActive
        firmId
        isBestPractice
        isGlobalBestPractice
        images {
            ...manufacturerProductImageDetailFragment
        }
        videos {
            ...manufacturerProductVideoDetailFragment
        }
        hasManufacturerOptions
        hasSupportedOptions
        isListingProductTypeManufacturerProductType
        contentLibrary
    }
    ${manufacturerProductImageDetailFragment}
    ${manufacturerProductVideoDetailFragment}
`
